import { render, staticRenderFns } from "./RightVsWrong.vue?vue&type=template&id=4b6ffe7e&scoped=true&"
import script from "./RightVsWrong.vue?vue&type=script&setup=true&lang=js&"
export * from "./RightVsWrong.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ffe7e",
  null
  
)

export default component.exports